module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAANBJREFUOE/tlL0RgzAMhZ/SwhAsEVIGtvA2gW28BaQMLMEQUCtn/AMhxPZdUqTAnc/y56cnS4QfL4rhpaIvRnluY2KDwFQ8KgbdFIzA9SgvlQ/8EahUMbjZu+wDvwENSCkq/Eq4Bk7t1ooX4Dq9GL/2bHDARHQcC9mLm2Q+sxzQqMsIyACeK8qgzKgYNIQKBgYCu72OXVLfpKwLYV8zj1wnmZcKl4iuIfDdVlplRaBy7eMBPDzUg+FPvs23rWc/+Kr1eu90CfW57ZbggA2BtudPX4wHJA075FEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon7.png
// module id = D70F
// module chunks = 1